import axios from '../../../../utills/axiosConfig';

export const fetchSubCategories = async (company_code) => {
  const params = {};
  if (company_code) params.company_code = company_code;
  const res = await axios.get('/sub-categories', { params });
  return res.data;
};

export const addSubCategory = async (subCategory) => {
  try {
    const res = await axios.post('/sub-categories', subCategory);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const updateSubCategory = async (id, subCategory) => {
  const res = await axios.put(`/sub-categories/${id}`, subCategory);
  return res.data;
};

export const deleteSubCategory = async (id) => {
  const res = await axios.delete(`/sub-categories/${id}`);
  return res.data;
};

export const importSubCategoryCSV = async (formData) => {
  const { data } = await axios.post('/sub-categories/upload-csv', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data;
}; 